import React from 'react';
import { useTranslation } from "react-i18next";
import FooterSection from '../../components/sections/FooterSection';
import HeroSection from '../../components/sections/HeroSection';

function BurabaiSightPage(props) 
{
    const { t } = useTranslation();

    return (
        <>
        <HeroSection 
            i18nTitleKey="infopages.sights.borovoye.title"
            i18nParagraphKey="infopages.sights.borovoye.subtitle"
            i18nCallToActionKey="infopages.sights.borovoye.cta"
            backgroundImageUrl="https://dwc.kg/wp-content/uploads/2023/06/1648766009_21-vsegda-pomnim-com-p-ozero-borovoe-kazakhstan-foto-22.jpg"
        />

        <div className="uk-container uk-margin-large-top uk-margin-large-bottom">
            <h1 className="uk-heading-medium uk-margin-bottom">
                {t("burabai.title", "Burabai National Park")}
            </h1>

            <p className="uk-text-lead uk-margin-bottom">
                {t(
                    "burabai.intro",
                    "Burabai, often called the 'Pearl of Kazakhstan', is a protected national park in the Akmola Region. Surrounded by pine forests, clear lakes, and unique rock formations, it is one of the most popular tourist destinations in the country."
                )}
            </p>

            <h2 className="uk-heading-line uk-text-bold">
                <span>{t("burabai.highlightsTitle", "Highlights")}</span>
            </h2>
            <ul className="uk-list uk-list-bullet uk-margin-bottom">
                <li>{t("burabai.highlight1", "Okzhetpes Rock, a natural monument with many legends.")}</li>
                <li>{t("burabai.highlight2", "Burabai Lake and smaller surrounding lakes with clean waters.")}</li>
                <li>{t("burabai.highlight3", "Pine forests providing fresh air and hiking opportunities.")}</li>
                <li>{t("burabai.highlight4", "Tourist infrastructure with resorts and sanatoriums.")}</li>
            </ul>

            <p className="uk-text uk-text-justify">
                {t(
                    "burabai.conclusion",
                    "Burabai combines natural beauty with cultural heritage, making it a must-visit destination for travelers seeking relaxation, nature, and history in Kazakhstan."
                )}
            </p>
        </div>
        <FooterSection />
        </>
    );
}

export default BurabaiSightPage;
